import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

const ObjetivoSection = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        py: 4,
        px: 3,
        borderRadius: 2,
        bgcolor: theme.palette.alternate.main,
        borderLeft: 4,
        borderColor: theme.palette.primary.main,
      }}
    >
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 700 }}
        variant="overline"
        color="primary"
        display="block"
        gutterBottom
      >
        Objetivo
      </Typography>
      <Typography variant="h5" fontWeight={700} gutterBottom>
        Sistema de control de gastos inteligente
      </Typography>
      <Typography variant="body1" color="textSecondary" paragraph>
        Desarrollar una aplicación web que permita registrar, visualizar y
        analizar de forma automatizada los egresos del negocio INDESAGRO,
        reduciendo el trabajo manual y mejorando la toma de decisiones.
      </Typography>
    </Box>
  );
};

export default ObjetivoSection;
